import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'
import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import BulkAssignUserTasksModal from '@modals/BulkAssignUserTasksModal'

import PageContent from './components/PageContent'

export type PageContextPayload = {
  callbacks: {
    showBulkAssignUserTasksModal: (payload: object) => void,
  },
}

// @ts-expect-error TS7006
const callbacks = (component: string, setState) => {
  const componentCallbacks = {
    BulkAssignUserTasksModal: {
      closeModal: () => setState({ showBulkAssignUserTasksModal: false }),
      bulkAssignUserTasks: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  // @ts-expect-error TS7053
  return componentCallbacks[component] || {}
}

const defaultState = {
  showBulkAssignUserTasksModal: false,
}

const Overview = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showBulkAssignUserTasksModal,
  } = state

  const modalContext = useModals()
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showBulkAssignUserTasksModal: (payload: object) => {
        setModalData('BulkAssignUserTasksModal', payload)
        setState({ showBulkAssignUserTasksModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <BulkAssignUserTasksModal
          callbacks={callbacks('BulkAssignUserTasksModal', setState)}
          requestOptions={{
            include_image_sizes: true,
            include_related_entity_subject: true,
            include_task_list_item_assignee: true,
            include_task_list_item_parent_task: true,
            include_task_list_item_related_entities: true,
            include_task_list_item_task_list: true,
            include_user_image: true,
          }}
          showModal={showBulkAssignUserTasksModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Overview
